import { render, staticRenderFns } from "./matrixselect.vue?vue&type=template&id=bde10646&scoped=true&"
import script from "./matrixselect.vue?vue&type=script&lang=js&"
export * from "./matrixselect.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bde10646",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/gitlab-runner/builds/3ztxUiUz/0/ifirst/dt-survey/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('bde10646')) {
      api.createRecord('bde10646', component.options)
    } else {
      api.reload('bde10646', component.options)
    }
    module.hot.accept("./matrixselect.vue?vue&type=template&id=bde10646&scoped=true&", function () {
      api.rerender('bde10646', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/FormGen/FormDesign/ItemConfig/matrixselect.vue"
export default component.exports